export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    slug: 'character-doujin',
    name: '角色同人本',
    description: '以原神角色为中心的同人创作合集，涵盖胡桃、钟离、雷电将军等人气角色的精彩同人作品。',
    icon: 'ri-user-heart-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20anime%20style%20illustration%20book%20cover%20featuring%20popular%20characters%20Hu%20Tao%20and%20Zhongli%20in%20warm%20traditional%20Chinese%20aesthetic%2C%20soft%20watercolor%20texture%2C%20elegant%20composition%2C%20artistic%20doujinshi%20cover%20design%20with%20golden%20accents%20and%20delicate%20linework%2C%20warm%20cream%20background%20with%20subtle%20floral%20patterns%2C%20high%20quality%20anime%20art%20style%2C%20collector%20edition%20feel&width=800&height=500&seq=cat-char-doujin&orientation=landscape',
  },
  {
    slug: 'doujin-comic',
    name: '同人漫画',
    description: '精彩纷呈的原神同人漫画作品，讲述提瓦特大陆上那些未被讲述的故事与冒险。',
    icon: 'ri-book-open-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20doujinshi%20manga%20pages%20spread%20open%20book%20with%20beautiful%20anime%20art%2C%20Teyvat%20adventure%20scenes%2C%20detailed%20black%20and%20white%20manga%20panels%20with%20color%20cover%2C%20warm%20lighting%20on%20open%20pages%2C%20artistic%20composition%2C%20cozy%20reading%20atmosphere%2C%20wooden%20desk%20surface%2C%20soft%20cream%20background%2C%20high%20quality%20print%20texture&width=800&height=500&seq=cat-comic&orientation=landscape',
  },
  {
    slug: 'illustration-book',
    name: '同人插画集',
    description: '汇聚顶尖画师的原神同人插画作品集，每一页都是视觉盛宴与艺术的碰撞。',
    icon: 'ri-palette-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20illustration%20art%20book%20collection%20featuring%20Ganyu%20and%20Keqing%20in%20stunning%20artistic%20style%2C%20vibrant%20watercolor%20and%20ink%20wash%20technique%2C%20elegant%20character%20portraits%2C%20soft%20pastel%20color%20palette%2C%20cream%20background%20with%20golden%20decorative%20borders%2C%20premium%20art%20book%20aesthetic%2C%20collector%20quality%20feel%2C%20warm%20ambient%20lighting&width=800&height=500&seq=cat-illust&orientation=landscape',
  },
  {
    slug: 'novel-book',
    name: '同人小说本',
    description: '文字与想象的交织——原神同人小说本，用笔触描绘角色们的内心世界与全新故事。',
    icon: 'ri-quill-pen-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20fan%20fiction%20novel%20book%20cover%20with%20elegant%20typography%20in%20Chinese%20characters%2C%20Raiden%20Shogun%20silhouette%20in%20soft%20ink%20wash%20style%2C%20traditional%20book%20binding%20aesthetic%2C%20warm%20cream%20paper%20texture%2C%20subtle%20lightning%20motif%2C%20literary%20magazine%20quality%2C%20minimalist%20design%20with%20Japanese%20influence%2C%20soft%20natural%20lighting%2C%20elegant%20composition&width=800&height=500&seq=cat-novel&orientation=landscape',
  },
  {
    slug: 'cp-doujin',
    name: 'CP同人本',
    description: '记录提瓦特大陆最动人的羁绊，CP向同人本合集，见证角色之间最真挚的情感。',
    icon: 'ri-hearts-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Genshin%20Impact%20romantic%20doujinshi%20cover%20featuring%20Kamisato%20Ayaka%20and%20traveler%20in%20cherry%20blossom%20scene%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20delicate%20anime%20art%20style%2C%20floating%20petals%2C%20warm%20emotional%20atmosphere%2C%20elegant%20book%20cover%20design%2C%20traditional%20Japanese%20aesthetic%20influence%2C%20soft%20natural%20lighting%2C%20romantic%20composition&width=800&height=500&seq=cat-cp&orientation=landscape',
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};